import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, liveAnnounce, UitkContextWrapper, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-step-input.css';
var getClassNameList = classNames.bind(styles);
var UitkStepInputLocalAnalyticsIdType;
(function (UitkStepInputLocalAnalyticsIdType) {
  UitkStepInputLocalAnalyticsIdType["add"] = "Add";
  UitkStepInputLocalAnalyticsIdType["remove"] = "Remove";
})(UitkStepInputLocalAnalyticsIdType || (UitkStepInputLocalAnalyticsIdType = {}));
var generateUniqueId = function (label, operationMethod) {
  var newOperationMethod = operationMethod ? "".concat(operationMethod, "-") : '';
  var randomNumber = Math.floor(Math.random() * 1000);
  return "uitk-step-".concat(newOperationMethod).concat(label.toLowerCase(), "-").concat(randomNumber.toString());
};
var UitkStepInput = /** @class */function (_super) {
  __extends(UitkStepInput, _super);
  function UitkStepInput(props) {
    var _this = _super.call(this, props) || this;
    _this.decrement = function () {
      var _a = _this.props,
        step = _a.step,
        value = _a.value;
      var newValue = Number(value);
      var result = newValue - step;
      _this.changeValue(result);
    };
    _this.increment = function () {
      var _a = _this.props,
        step = _a.step,
        value = _a.value;
      var newValue = Number(value);
      var result = newValue + step;
      _this.changeValue(result);
    };
    _this.inputChange = function (event) {
      return _this.changeValue(event.target.value);
    };
    _this.changeValue = function (value) {
      var _a = _this.props,
        onChange = _a.onChange,
        min = _a.min,
        max = _a.max,
        label = _a.label;
      var changedValue = {
        target: {
          value: value.toString()
        }
      };
      if (value < min || value > max) {
        return null;
      }
      liveAnnounce("".concat(value.toString(), " ").concat(label));
      if (onChange) {
        onChange(changedValue);
      }
    };
    _this.state = {
      isMounted: false
    };
    _this.setInputId = _this.setInputId.bind(_this);
    return _this;
  }
  UitkStepInput.prototype.componentDidMount = function () {
    this.setState({
      isMounted: true
    });
  };
  UitkStepInput.prototype.getDecrementIconId = function () {
    var _a = this.props,
      decrementId = _a.decrementId,
      label = _a.label;
    return decrementId || generateUniqueId(label, 'decrement');
  };
  UitkStepInput.prototype.getIncrementIconId = function () {
    var _a = this.props,
      incrementId = _a.incrementId,
      label = _a.label;
    return incrementId || generateUniqueId(label, 'increment');
  };
  UitkStepInput.prototype.setInputId = function () {
    var _a = this.props,
      id = _a.id,
      label = _a.label;
    this.inputId = id || generateUniqueId(label);
  };
  UitkStepInput.prototype.render = function () {
    var _this = this;
    var isMounted = this.state.isMounted;
    var _a = this.props,
      decrementText = _a.decrementText,
      incrementText = _a.incrementText,
      className = _a.className,
      analytics = _a.analytics,
      description = _a.description,
      decrementRef = _a.decrementRef,
      incrementRef = _a.incrementRef,
      value = _a.value,
      label = _a.label,
      step = _a.step,
      min = _a.min,
      max = _a.max,
      required = _a.required;
    var ariaLabel = [label, description].filter(function (elem) {
      return !!elem;
    }).toString();
    var isNextDecrementUnderMinimum = Number(value) - step < min;
    var isNextIncrementAboveMaximum = Number(value) + step > max;
    var isDecrementDisabled = !isMounted || isNextDecrementUnderMinimum;
    var isIncrementDisabled = !isMounted || isNextIncrementAboveMaximum;
    var inputType = isMounted ? 'text' : 'number';
    var inputTabIndex = isMounted ? -1 : 0;
    var baseClassName = 'uitk-step-input';
    var wrapperClassNames = getClassNameList("".concat(baseClassName), className, {
      'uitk-step-input-mounted': isMounted
    });
    var labelCssClassName = getClassNameList("".concat(baseClassName, "-label-section"), {
      'is-required': required
    });
    var decrementAnalytics = analytics && __assign({
      localAnalyticsId: UitkStepInputLocalAnalyticsIdType.remove
    }, analytics);
    var incrementAnalytics = analytics && __assign({
      localAnalyticsId: UitkStepInputLocalAnalyticsIdType.add
    }, analytics);
    this.setInputId();
    return React.createElement(UitkContextWrapper, null, function (context, data) {
      return React.createElement(UitkLayoutFlex, {
        className: wrapperClassNames,
        alignItems: "center",
        justifyContent: "space-between"
      }, React.createElement(UitkLayoutFlexItem, {
        className: labelCssClassName,
        grow: 1
      }, React.createElement("label", {
        htmlFor: _this.inputId
      }, label && React.createElement("span", {
        className: getClassNameList("".concat(baseClassName, "-label"))
      }, label, required && (data === null || data === void 0 ? void 0 : data.hasRequiredFieldIndicator) && React.createElement("span", {
        "aria-hidden": "true",
        className: "uitk-step-input-required-asterisk"
      }, ' ', "*")), description && React.createElement("span", {
        className: getClassNameList("".concat(baseClassName, "-description"))
      }, description))), React.createElement(UitkLayoutFlexItem, {
        className: getClassNameList("".concat(baseClassName, "-controls"))
      }, React.createElement(UitkLayoutFlex, null, React.createElement(UitkLayoutFlexItem, {
        className: getClassNameList("".concat(baseClassName, "-touch-target"))
      }, React.createElement("button", {
        type: "button",
        disabled: isDecrementDisabled,
        onClick: _this.decrement,
        onClickCapture: analyticsTracker.bind(_this, decrementAnalytics),
        ref: decrementRef
      }, React.createElement("span", {
        className: getClassNameList("".concat(baseClassName, "-button"))
      }, React.createElement(UitkIcon, {
        className: getClassNameList("".concat(baseClassName, "-icon")),
        name: "remove",
        title: decrementText,
        id: _this.getDecrementIconId()
      })))), React.createElement(UitkLayoutFlexItem, {
        className: getClassNameList("".concat(baseClassName, "-value"))
      }, React.createElement("input", {
        type: inputType,
        id: _this.inputId,
        value: value,
        onChange: _this.inputChange,
        min: min,
        max: max,
        tabIndex: inputTabIndex,
        readOnly: isMounted,
        "aria-label": ariaLabel
      })), React.createElement(UitkLayoutFlexItem, {
        className: getClassNameList("".concat(baseClassName, "-touch-target"))
      }, React.createElement("button", {
        type: "button",
        disabled: isIncrementDisabled,
        onClick: _this.increment,
        onClickCapture: analyticsTracker.bind(_this, incrementAnalytics),
        ref: incrementRef
      }, React.createElement("span", {
        className: getClassNameList("".concat(baseClassName, "-button"))
      }, React.createElement(UitkIcon, {
        className: getClassNameList("".concat(baseClassName, "-icon")),
        name: "add",
        title: incrementText,
        id: _this.getIncrementIconId()
      })))))));
    });
  };
  UitkStepInput.displayName = 'UitkStepInput';
  UitkStepInput.defaultProps = {
    max: 99,
    min: 0,
    step: 1,
    value: 0
  };
  return UitkStepInput;
}(React.Component);
export { UitkStepInput, UitkStepInputLocalAnalyticsIdType };